import { AffiliateApproval } from '@core/models/affiliate-approval.model';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';

@Injectable()
export class AffiliateApprovalEntityService extends EntityCollectionServiceBase<AffiliateApproval> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('AffiliateApproval', serviceElementsFactory);
  }
}